import { render, staticRenderFns } from "./UpgradeBadgeDialog.vue?vue&type=template&id=094d61af&scoped=true"
import script from "./UpgradeBadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeBadgeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UpgradeBadgeDialog.vue?vue&type=style&index=0&id=094d61af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094d61af",
  null
  
)

export default component.exports